import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Box, Button, Select, Container, Table, Pagination, TableBody, TableCell, TableHead, TableRow, TextField } from "@mui/material";
import axios from "axios";
import swal from "sweetalert";
import { t } from "i18next";
import { useEffect, useState, useRef } from "react";
import { GetNameChoose } from "../../funcUtils";

// Khai báo Interceptors ở ngoài Component
axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("user");
        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

function HistoryBetAll() {
    const [data, setData] = useState(null);
    const [searched, setSearched] = useState("");
    const [isShow, setShow] = useState(false);
    const [ls, setLs] = useState(null);
    const [isLoading, setLoading] = useState(false);
    const [endDate, setEndDate] = useState(new Date());
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [total, setTotal] = useState(null);
    const [isOpen, setIsOpen] = useState(false);

    // States cho phân trang và tìm kiếm
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const limit = 12;
    const typingTimeoutRef = useRef(null);

    const openPopup = (item) => {
        setTotal(item);
        setIsOpen(true);
    };
    const closePopup = () => {
        setIsOpen(false);
    };

    function formatDate(m) {
        new Date(m);
        const dateString =
            m.getUTCFullYear() +
            "/" +
            ("0" + (m.getMonth() + 1)).slice(-2) +
            "/" +
            ("0" + m.getDate()).slice(-2) +
            "  " +
            ("0" + m.getHours()).slice(-2) +
            ":" +
            ("0" + m.getMinutes()).slice(-2);
        return dateString;
    }

    // 🔥 HÀM DỊCH MÃ CƯỢC XÓC ĐĨA (FIX LUÔN LỖI CHỮ 'CHỌ' CỦA BACKEND) 🔥
    const getXocDiaBetLabel = (stateStr) => {
        if (!stateStr) return "";
        const map = {
            "6": "Lẻ", "5": "Chẵn", "4": "3 Trắng, 1 Đỏ", "3": "3 Đỏ, 1 Trắng", "2": "4 Trắng", "1": "4 Đỏ",
            "le": "Lẻ", "lẻ": "Lẻ", "chan": "Chẵn", "chẵn": "Chẵn", "chọ": "Chẵn"
        };
        return String(stateStr).trim().split(/\s+/).map(s => map[s.toLowerCase()] || map[s] || s).join(", ");
    };

    // 🔥 HÀM DỊCH MÃ CƯỢC TÀI XỈU (FIX LUÔN LỖI CHỮ 'CHỌ' CỦA BACKEND) 🔥
    const getTaiXiuBetLabel = (stateStr) => {
        if (!stateStr) return "";
        const map = {
            "1": "Tài", "2": "Xỉu", "3": "Chẵn", "4": "Lẻ",
            "tai": "Tài", "tài": "Tài", "xiu": "Xỉu", "xỉu": "Xỉu",
            "chan": "Chẵn", "chẵn": "Chẵn", "chọ": "Chẵn", "le": "Lẻ", "lẻ": "Lẻ"
        };
        return String(stateStr).trim().split(/\s+/).map(s => map[s.toLowerCase()] || map[s] || s).join(", ");
    };

    // Hàm gọi API fetching dữ liệu
    const fetchHistory = () => {
        setLoading(true);
        axios
            .get(`${process.env.REACT_APP_API_URL}/history/all?date=${endDate}&page=${page}&limit=${limit}&search=${searched}`)
            .then((res) => {
                setData(res.data.data);
                if (res.data.totalPages) setTotalPages(res.data.totalPages);
                setLoading(false);
            })
            .catch((err) => {
                setData(null);
                setLoading(false);
            });
    };

    // Tự động fetch khi page, date hoặc từ khóa search thay đổi
    useEffect(() => {
        fetchHistory();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, endDate, searched]);

    // Xử lý tìm kiếm có Debounce
    const handleSearchChange = (e) => {
        const value = e.target.value;
        if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);
        
        typingTimeoutRef.current = setTimeout(() => {
            setSearched(value);
            setPage(1); // Trở về trang 1 khi tìm kiếm
        }, 500);
    };

    const handleChangePage = (e, newPage) => {
        setPage(newPage);
    };

    const [st, setSt] = useState(0);
    const handleChangeStatus = (e) => {
        if (ls?.status_bet === "Lose" || ls?.status_bet === "Pending") {
            if (e.target.value === "Win") {
                setSt(1);
            }
        } else {
            if (e.target.value === "Lose" || e.target.value === "Pending") {
                setSt(2);
            }
        }
        setLs((prevLs) => ({
            ...prevLs,
            status_bet: e.target.value
        }));
    };

    const handleSubmitLs = (e) => {
        e.preventDefault();
        const formData = {
            id: ls?._id,
            userId: ls?.user?._id,
            status_bet: e.target.status_bet.value,
            state: e.target.state.value,
            money: e.target.money.value,
            moneyuser: st == 1 ? e.target.moneythang.value : st == 2 ? Number(ls?.moneythang) * -1 : 0,
            moneythang: e.target.moneythang.value
        };
        axios
            .patch(`${process.env.REACT_APP_API_URL}/history`, formData)
            .then((res) => {
                setShow(false);
                swal(t('success'), "", "success").then((value) => {
                    fetchHistory(); 
                });
            })
            .catch((err) => {
                setShow(false);
                swal(t('error'), "", "error");
            });
    };

    return (
        <>
            <ThemeProvider theme={theme}>
                <DashboardLayout>
                    <Box
                        component="main"
                        sx={{
                            flexGrow: 1,
                            py: 1
                        }}>
                        {isLoading ? (
                            <div className="loading" style={{ maxWidth: "100%" }}>
                                <div className="loader"></div>
                            </div>
                        ) : null}
                        <Container maxWidth={false}>
                            <div className="container_set">{t("history_play")}</div>
                            <div className="form_set">
                                <Box sx={{ overflowX: 'auto' }}>
                                    <div style={{ display: "flex", justifyContent: "space-between", width: "100%", maxWidth: "600px", margin: "auto", marginBottom: "15px" }}>
                                        <TextField defaultValue="" onChange={handleSearchChange} placeholder={t("search")} />
                                        <DatePicker
                                            maxDate={new Date()}
                                            selected={endDate}
                                            onChange={(date) => {
                                                setEndDate(date);
                                                setPage(1);
                                            }}
                                        />
                                    </div>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{ padding: "10px", minWidth: '80px' }}>{t("session")}</TableCell>
                                                <TableCell sx={{ padding: "10px", minWidth: '120px' }}>{t("username")}</TableCell>
                                                <TableCell sx={{ padding: "10px", minWidth: '100px' }}>{t("balance")}</TableCell>
                                                <TableCell sx={{ padding: "10px", minWidth: '120px' }}>{t("game")}</TableCell>
                                                <TableCell sx={{ padding: "10px", minWidth: '150px' }}>{t("bet")}</TableCell>
                                                <TableCell sx={{ padding: "10px", minWidth: '150px', textAlign: 'center' }}>{t("result")}</TableCell>
                                                <TableCell sx={{ padding: "10px", minWidth: '100px' }}>{t("money_bet")}</TableCell>
                                                <TableCell sx={{ padding: "10px", minWidth: '100px' }}>{t("money_win")}</TableCell>
                                                <TableCell sx={{ padding: "10px", minWidth: '100px' }}>{t("status")}</TableCell>
                                                <TableCell sx={{ padding: "10px", minWidth: '120px' }}>{t("time")}</TableCell>
                                                {profile?.permission?.set == 1 ? <TableCell sx={{ padding: "10px" }}>{t("edit")}</TableCell> : null}
                                            </TableRow>
                                        </TableHead>
                                        {data != null && data.length > 0 ? (
                                            <TableBody>
                                                {data.map((item) => {
                                                    // 🔥 LOGIC NHẬN DIỆN TÊN GAME VÀ HIỂN THỊ CỘT GAME CHUẨN XÁC 🔥
                                                    let gameType = "UNKNOWN";
                                                    const sanhStr = String(item?.sanh || "").trim();
                                                    const sanhLower = sanhStr.toLowerCase();
                                                    const typeStr = String(item?.type || "").trim().toUpperCase();
                                                    const gameName = String(item?.game || "").trim();

                                                    if (typeStr.includes("XD")) {
                                                        gameType = "XOCDIA";
                                                    } else if (typeStr.includes("TX")) {
                                                        gameType = "TAIXIU";
                                                    } else if (typeStr.includes("CATDOG")) {
                                                        gameType = "CATDOG";
                                                    } else if (typeStr.includes("XS") || gameName.toLowerCase().includes("xổ số") || sanhLower.includes("xs")) {
                                                        gameType = "XOSO";
                                                    } else if (sanhLower.includes("xổ số")) {
                                                        gameType = "XOSO";
                                                    } else if (sanhLower.includes("catdog") || sanhLower.includes("cat dog")) {
                                                        gameType = "CATDOG";
                                                    } else if (sanhLower.includes("tài xỉu") || sanhLower.includes("tx")) {
                                                        gameType = "TAIXIU";
                                                    } else if (sanhLower.includes("xóc đĩa") || sanhLower.includes("xd")) {
                                                        gameType = "XOCDIA";
                                                    } else if (item?.id_bet?.result) {
                                                        const parts = item.id_bet.result.trim().split(/\s+/);
                                                        if (parts.length === 3) gameType = "TAIXIU";
                                                        else if (parts.length === 4) gameType = "XOCDIA";
                                                    }

                                                    // Format lại cột GAME (Biến "1" thành "Xóc Đĩa (Sảnh 1)", "Tài xỉu 4" thành "Tài xỉu Sảnh 4")
                                                    let gameNameDisplay = sanhStr; 
                                                    if (gameName && gameName !== "null" && gameName !== "") {
                                                        gameNameDisplay = `${gameName} (Sảnh ${sanhStr})`;
                                                    } else if (gameType === "TAIXIU") {
                                                        if (/^\d+$/.test(sanhStr)) {
                                                            gameNameDisplay = `Tài xỉu Sảnh ${sanhStr}`;
                                                        } else if (sanhLower.match(/^tài xỉu \d+$/)) {
                                                            gameNameDisplay = sanhStr.replace(/tài xỉu/i, "Tài xỉu Sảnh");
                                                        }
                                                    } else if (gameType === "XOCDIA") {
                                                        if (/^\d+$/.test(sanhStr)) {
                                                            gameNameDisplay = `Xóc đĩa Sảnh ${sanhStr}`;
                                                        } else if (sanhLower.match(/^xóc đĩa \d+$/)) {
                                                            gameNameDisplay = sanhStr.replace(/xóc đĩa/i, "Xóc đĩa Sảnh");
                                                        }
                                                    }

                                                    let mockSanh = sanhStr;
                                                    if (gameType === "TAIXIU") mockSanh = "Tài xỉu";
                                                    if (gameType === "XOCDIA") mockSanh = "Xóc đĩa";

                                                    // Dịch cột BET (Bắt lỗi chữ "Chọ")
                                                    let displayBet = "";
                                                    if (gameType === "XOCDIA") {
                                                        displayBet = getXocDiaBetLabel(item?.state);
                                                    } else if (gameType === "TAIXIU") {
                                                        displayBet = getTaiXiuBetLabel(item?.state);
                                                    } else if (gameType === "CATDOG") {
                                                        displayBet = GetNameChoose(item?.id_bet?.result?.slice(-1), null, "CatDog").replace("Chọn ", "");
                                                    } else {
                                                        displayBet = GetNameChoose(item?.state, item?.type, mockSanh);
                                                    }

                                                    return (
                                                        <TableRow key={item._id} hover>
                                                            <TableCell sx={{ fontWeight: "600", padding: "10px" }}>
                                                                {item?.id_bet?.id_bet ? item?.id_bet?.id_bet : item?.id_bet}
                                                            </TableCell>
                                                            <TableCell sx={{ fontWeight: "600", padding: "10px", color: "#1976d2" }}>
                                                                {item?.user?.username}
                                                            </TableCell>
                                                            <TableCell sx={{ fontWeight: "600", padding: "10px" }}>
                                                                {Math.floor(item?.user?.money || 0).toLocaleString("vi-VN")}
                                                            </TableCell>
                                                            
                                                            {/* 🔥 CỘT GAME ĐÃ ĐƯỢC CHUẨN HOÁ 🔥 */}
                                                            <TableCell sx={{ fontWeight: "bold", padding: "10px" }}>
                                                                {gameNameDisplay}
                                                            </TableCell>

                                                            {/* 🔥 CỘT BET ĐÃ ĐƯỢC FIX LỖI CHỮ "CHỌ" 🔥 */}
                                                            <TableCell sx={{ fontWeight: "600", padding: "10px", color: '#d32f2f' }}>
                                                                Chọn: {displayBet}
                                                            </TableCell>

                                                            <TableCell sx={{ textAlign: "center", display: 'flex', justifyContent: 'center' }}>
                                                                {item?.id_bet && (
                                                                    <>
                                                                        {gameType === "XOCDIA" && (
                                                                            <div
                                                                                className="history_xd"
                                                                                style={{
                                                                                    display: "flex",
                                                                                    justifyContent: "center",
                                                                                    transform: "scale(0.9)"
                                                                                }}>
                                                                                {item?.id_bet?.result?.trim().split(" ").map((x, i) => (
                                                                                    <div key={i} className={`a${x}`}></div>
                                                                                ))}
                                                                            </div>
                                                                        )}
                                                                        
                                                                        {gameType === "TAIXIU" && (
                                                                            <div
                                                                                className="history_xucsac"
                                                                                style={{
                                                                                    display: "flex",
                                                                                    justifyContent: "center",
                                                                                    transform: "scale(2.2)"
                                                                                }}>
                                                                                {item?.id_bet?.result?.trim().split(" ").map((x, i) => (
                                                                                    <div key={i} className={`n${x}`}></div>
                                                                                ))}
                                                                            </div>
                                                                        )}

                                                                        {/* 🔥 FIX NÚT XEM KẾT QUẢ CHO XỔ SỐ: CHẮC CHẮN HIỂN THỊ 🔥 */}
                                                                        {gameType === "XOSO" && (
                                                                            <Button
                                                                                size="small"
                                                                                variant="contained"
                                                                                color="error"
                                                                                sx={{ borderRadius: "10px", fontWeight: "bold" }}
                                                                                onClick={() => openPopup(item?.id_bet)}>
                                                                                {t("view")}
                                                                            </Button>
                                                                        )}
                                                                        
                                                                        {gameType === "CATDOG" && (
                                                                            <>{GetNameChoose(item?.id_bet?.result?.slice(-1), null, "CatDog").replace("Chọn ", "")}</>
                                                                        )}
                                                                    </>
                                                                )}
                                                            </TableCell>

                                                            <TableCell sx={{ fontWeight: "bold", padding: "10px", color: '#2e7d32' }}>
                                                                {item?.money.toLocaleString("vi-VN")}
                                                            </TableCell>
                                                            <TableCell sx={{ fontWeight: "bold", padding: "10px", color: '#1976d2' }}>
                                                                {item?.moneythang.toLocaleString("vi-VN")}
                                                            </TableCell>
                                                            <TableCell sx={{ fontWeight: "600", padding: "10px" }}>
                                                                {item?.status_bet === "Win" ? (
                                                                    <span className="badge success">{t("win")}</span>
                                                                ) : item?.status_bet === "Lose" ? (
                                                                    <span className="badge error">{t("lose")}</span>
                                                                ) : item?.status_bet === "Pending" ? (
                                                                    <span className="badge warning">{t("pending")}</span>
                                                                ) : (
                                                                    <span className="badge cancel">{t("canceled")}</span>
                                                                )}
                                                            </TableCell>

                                                            <TableCell sx={{ fontWeight: "500", padding: "10px", fontSize: '13px' }}>
                                                                {formatDate(new Date(item?.createdAt))}
                                                            </TableCell>
                                                            
                                                            {profile?.permission?.set == 1 ? (
                                                                <TableCell sx={{ padding: "10px" }}>
                                                                    <Button
                                                                        size="small"
                                                                        variant="outlined"
                                                                        onClick={() => {
                                                                            setShow(true);
                                                                            setLs(item);
                                                                        }}>
                                                                        {t("edit")}
                                                                    </Button>
                                                                </TableCell>
                                                            ) : null}
                                                        </TableRow>
                                                    );
                                                })}
                                            </TableBody>
                                        ) : (
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell colSpan={12} align="center">{t("empty")}</TableCell>
                                                </TableRow>
                                            </TableBody>
                                        )}
                                    </Table>
                                </Box>
                            </div>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    pt: 3
                                }}>
                                {data != null ? <Pagination color="primary" page={page} count={totalPages} size="small" onChange={handleChangePage} /> : null}
                            </Box>
                        </Container>
                    </Box>

                    {/* MODAL SỬA VÉ CƯỢC */}
                    {isShow === true ? (
                        <>
                            <div className="modal">
                                <div className="modaloverlay">
                                    <i className="ti-close closelogin" onClick={() => setShow(false)}></i>
                                </div>
                                <div className="modalbody">
                                    <form onSubmit={handleSubmitLs}>
                                        <div className="modalinner">
                                            <div className="modalheader"> {t("edit")} </div>

                                            <div className="modalform">
                                                <div className="modalformgroup d-flex" style={{ padding: "9px" }}>
                                                    <div>{t("username")}: </div>
                                                    <div>
                                                        <b>{ls?.user?.username}</b>
                                                    </div>
                                                </div>
                                                <div className="modalformgroup d-flex" style={{ padding: "9px" }}>
                                                    <div>{t("game")}: </div>
                                                    <div>
                                                        <b>{ls?.sanh}</b>
                                                    </div>
                                                </div>
                                                <div style={{ padding: "9px" }} className="modalformgroup d-flex">
                                                    <div>{t("bet")}: </div>
                                                    <TextField name="state" defaultValue={ls?.state} sx={{ width: "100%" }} type="text" />
                                                </div>
                                                <div style={{ padding: "9px" }} className="modalformgroup d-flex">
                                                    <div>{t("money_bet")}: </div>
                                                    <TextField name="money" defaultValue={ls?.money} sx={{ width: "100%" }} type="number" />
                                                </div>
                                                <div style={{ padding: "9px" }} className="modalformgroup d-flex">
                                                    <div>{t("money_win")}: </div>
                                                    <TextField name="moneythang" defaultValue={ls?.moneythang} sx={{ width: "100%" }} type="number" />
                                                </div>
                                                <div style={{ padding: "9px" }} className="modalformgroup d-flex">
                                                    <div>{t("status")}: </div>
                                                    <div>
                                                        <select name="status_bet" value={ls?.status_bet} onChange={handleChangeStatus}>
                                                            <option value="Win" selected={ls?.status_bet === "Win"} style={{ color: "#14B8A6" }}>
                                                                {t("win")}
                                                            </option>
                                                            <option value="Lose" selected={ls?.status_bet === "Lose"} style={{ color: "#D14343" }}>
                                                                {t("lose")}
                                                            </option>
                                                            <option value="Pending" selected={ls?.status_bet === "Pending"} style={{ color: "#FFB020" }}>
                                                                {t("pending")}
                                                            </option>
                                                            <option value="Cancelled" selected={ls?.status_bet === "Cancelled"} style={{ color: "#eee" }}>
                                                                {t("canceled")}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="item_btn_form">
                                                <div className="modalformcontrols">
                                                    <Button type="submit">{t("submit")}</Button>
                                                </div>
                                                <div className="modalformcontrols">
                                                    <Button onClick={() => setShow(false)}>{t("close")}</Button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </>
                    ) : null}
                    
                    {/* MODAL XEM CHI TIẾT XỔ SỐ */}
                    {isOpen && total ? (
                        <div className="popup-backdrop" style={{ maxWidth: "100%", zIndex: 9999 }}>
                            <div className="popup-main" style={{ maxWidth: "500px", margin: "0 auto" }}>
                                <div className="popup-header" style={{ fontSize: "18px" }}>
                                    {t("session")} {total?.id_bet}
                                </div>
                                <div className="popup-content" style={{ padding: "0" }}>
                                    <table id="table-xsmb" className="table-result table table-bordered table-striped table-xsmb">
                                        <tbody>
                                            <tr>
                                                <th style={{ width: "10%" }}>ĐB</th>
                                                <td>
                                                    <span id="mb_prize_0" className="special-prize div-horizontal">
                                                        {total?.dacbiet}
                                                    </span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>1</th>
                                                <td>
                                                    <span id="mb_prize_1" className="prize1 div-horizontal">
                                                        {total?.nhat}
                                                    </span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>2</th>
                                                <td>
                                                    <span id="mb_prize_2" className="prize2 div-horizontal">
                                                        {total?.hai?.split(" ")[0]}
                                                    </span>
                                                    <span id="mb_prize_3" className="prize2 div-horizontal">
                                                        {total?.hai?.split(" ")[1]}
                                                    </span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>3</th>
                                                <td>
                                                    <span id="mb_prize_4" className="prize3 div-horizontal">
                                                        {total?.ba?.split(" ")[0]}
                                                    </span>
                                                    <span id="mb_prize_5" className="prize3 div-horizontal">
                                                        {total?.ba?.split(" ")[1]}
                                                    </span>
                                                    <span id="mb_prize_6" className="prize3 div-horizontal">
                                                        {total?.ba?.split(" ")[2]}
                                                    </span>
                                                    <span id="mb_prize_7" className="prize3 div-horizontal">
                                                        {total?.ba?.split(" ")[3]}
                                                    </span>
                                                    <span id="mb_prize_8" className="prize3 div-horizontal">
                                                        {total?.ba?.split(" ")[4]}
                                                    </span>
                                                    <span id="mb_prize_9" className="prize3 div-horizontal">
                                                        {total?.ba?.split(" ")[5]}
                                                    </span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>4</th>
                                                <td>
                                                    <span id="mb_prize_10" className="prize4 div-horizontal">
                                                        {total?.tu?.split(" ")[0]}
                                                    </span>
                                                    <span id="mb_prize_11" className="prize4 div-horizontal">
                                                        {total?.tu?.split(" ")[1]}
                                                    </span>
                                                    <span id="mb_prize_12" className="prize4 div-horizontal">
                                                        {total?.tu?.split(" ")[2]}
                                                    </span>
                                                    <span id="mb_prize_13" className="prize4 div-horizontal">
                                                        {total?.tu?.split(" ")[3]}
                                                    </span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>5</th>
                                                <td>
                                                    <span id="mb_prize_14" className="prize5 div-horizontal">
                                                        {total?.nam?.split(" ")[0]}
                                                    </span>
                                                    <span id="mb_prize_15" className="prize5 div-horizontal">
                                                        {total?.nam?.split(" ")[1]}
                                                    </span>
                                                    <span id="mb_prize_16" className="prize5 div-horizontal">
                                                        {total?.nam?.split(" ")[2]}
                                                    </span>
                                                    <span id="mb_prize_17" className="prize5 div-horizontal">
                                                        {total?.nam?.split(" ")[3]}
                                                    </span>
                                                    <span id="mb_prize_18" className="prize5 div-horizontal">
                                                        {total?.nam?.split(" ")[4]}
                                                    </span>
                                                    <span id="mb_prize_19" className="prize5 div-horizontal">
                                                        {total?.nam?.split(" ")[5]}
                                                    </span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>6</th>
                                                <td>
                                                    <span id="mb_prize_20" className="prize6 div-horizontal">
                                                        {total?.sau?.split(" ")[0]}
                                                    </span>
                                                    <span id="mb_prize_21" className="prize6 div-horizontal">
                                                        {total?.sau?.split(" ")[1]}
                                                    </span>
                                                    <span id="mb_prize_22" className="prize6 div-horizontal">
                                                        {total?.sau?.split(" ")[2]}
                                                    </span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>7</th>
                                                <td>
                                                    <span id="mb_prize_23" className="prize7 div-horizontal">
                                                        {total?.bay?.split(" ")[0]}
                                                    </span>
                                                    <span id="mb_prize_24" className="prize7 div-horizontal">
                                                        {total?.bay?.split(" ")[1]}
                                                    </span>
                                                    <span id="mb_prize_25" className="prize7 div-horizontal">
                                                        {total?.bay?.split(" ")[2]}
                                                    </span>
                                                    <span id="mb_prize_26" className="prize7 div-horizontal">
                                                        {total?.bay?.split(" ")[3]}
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <button
                                    onClick={closePopup}
                                    className="popup-close"
                                    style={{
                                        background: "#00b977",
                                        boxShadow: "none",
                                        textShadow: "none",
                                        fontSize: "18px"
                                    }}>
                                    {t("close")}
                                </button>
                            </div>
                        </div>
                    ) : null}
                </DashboardLayout>

                {/* 🔥 VẼ XÚC XẮC TÀI XỈU VÀ ĐỒNG XU XÓC ĐĨA BẰNG CSS THUẦN 🔥 */}
                <style>{`
                  `}</style>
            </ThemeProvider>
        </>
    );
}

export default HistoryBetAll;